import styles from './CirclePreloader.module.scss'
import preloader from './image/preloader.svg'
const CirclePreloader = () => {
    return <div className={styles.box}>
      <img className={styles.img} src={preloader} alt="preloader"/>
    </div>
}

export default CirclePreloader
